
export class CustomerIndividualBiometric {
    public id: number;
    public customerNumberId: number;
    public genderTypeId: number;
    public hairColorTypeId: number;
    public eyeColorTypeId: number;
    public height: number;
    public weight: number;
    public dateOfBirth: any;
    public deceasedDate: any;

    public updatedBy: string;
    public updatedDate: any;

    public gender: string;
    public hairColor: string;
    public eyeColor: string;
    public displayHeight: string;
    public displayWeight: string;
    public age: number;
    public isBiometricRedacted: boolean;
}
